export default "__VITE_ASSET__CHwufuzf__"